import * as Yup from 'yup'

import { TypeOfEquipment } from 'api'

export const validationSchema = Yup.object({
  typeOfEquipment: Yup.array(Yup.mixed<TypeOfEquipment>().required()).default([]),
})
